import React, { useState } from "react";

import { interfaceElementsSelector } from "store/slices/themeSlice";

import { useAppSelector } from "hooks/store";

import { INTERFACE_ELEMENTS } from "themes/constants";

import menuSvg from "../../../resources/icons/menu.svg";
import xSvg from "../../../resources/icons/x.svg";
import TabMenu from "../tab-menu/tab-menu";
import useWindowSize from "../../../hooks/use-window-size";
import Divider from "../divider";
import Center from "../center";

import styles from "./header.module.css";
import HeaderLogo from "./components/header-logo";
import LangSwitch from "./components/lang-switch";

const Header = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { width } = useWindowSize();
  const renderMenuButton = (
    <img src={isOpen ? xSvg : menuSvg} alt="" className={styles.menuIcon} />
  );
  const interfaceElements = useAppSelector(interfaceElementsSelector);

  return (
    <>
      {interfaceElements.includes(INTERFACE_ELEMENTS.HEADER) ? (
        <>
          <div className={styles.container}>
            <div className={styles.wrapper}>
              <div className={styles.logoContainer}>
                <div
                  className={styles.menuButtonContainer}
                  onClick={() => setIsOpen((prev) => !prev)}
                >
                  <div>{renderMenuButton}</div>
                </div>
                <HeaderLogo />
              </div>
              <LangSwitch />
            </div>
          </div>
          <Center>
            {width <= 986 ? (
              <TabMenu isShow={isOpen} />
            ) : (
              <TabMenu isShow={true} />
            )}
          </Center>
          <Divider />
        </>
      ) : (
        <div className={styles.placeholderContainer}></div>
      )}
    </>
  );
};

export default Header;
